// Norske mobilnumre til E.164. Samme regel som functions/src/carrierValidation.js.
export function normalizeNorwegianPhone(input) {
  const raw = String(input ?? '').replace(/[\s()-]/g, '');
  const m = raw.match(/^(?:\+47|0047)?([49]\d{7})$/);
  return m ? `+47${m[1]}` : null;
}

// '+4791234567' blir '912 34 567'. Andre verdier vises som de er.
export function formatPhone(e164) {
  const m = /^\+47(\d{3})(\d{2})(\d{3})$/.exec(e164 ?? '');
  return m ? `${m[1]} ${m[2]} ${m[3]}` : (e164 ?? '');
}
